import { useState } from "react";
import { Button, Input, Typography } from "antd";
import { useTranslation } from "../../i18n";

const { Title, Paragraph } = Typography;

// 选片人姓名录入页（仅用作标识）。在知情同意之后、进入相册之前展示。
function SelectionNameGate({ albumName, defaultName = "", onSubmit, onBack }) {
    const { t } = useTranslation();
    const [name, setName] = useState(defaultName);
    const [error, setError] = useState("");

    const handleSubmit = () => {
        const trimmed = name.trim();
        if (!trimmed) {
            setError(t("selection.name.required"));
            return;
        }
        setError("");
        onSubmit(trimmed);
    };

    return (
        <div className="delivery-card selection-name-gate">
            <Title level={3} className="delivery-consent__title">
                {t("selection.name.title")}
            </Title>
            {albumName && (
                <Paragraph className="selection-name-gate__album">{albumName}</Paragraph>
            )}
            <Paragraph className="delivery-consent__text">{t("selection.name.subtitle")}</Paragraph>

            <Input
                size="large"
                value={name}
                maxLength={80}
                placeholder={t("selection.name.placeholder")}
                onChange={(e) => setName(e.target.value)}
                onPressEnter={handleSubmit}
                status={error ? "error" : undefined}
            />
            {error && (
                <Paragraph type="danger" style={{ marginTop: "0.5rem", marginBottom: 0 }}>
                    {error}
                </Paragraph>
            )}

            <div className="delivery-consent__actions">
                <Button type="primary" size="large" block onClick={handleSubmit}>
                    {t("selection.name.start")}
                </Button>
                {onBack && (
                    <Button type="default" size="large" block onClick={onBack}>
                        {t("selection.name.back")}
                    </Button>
                )}
            </div>
        </div>
    );
}

export default SelectionNameGate;
